import React from 'react';
import { Link } from 'react-router-dom';
import { FileUploadDebugger } from '../components/FileUploadDebugger';

export const DebugTools: React.FC = () => {
  const tools = [
    {
      name: 'AI Integration Debugger',
      description: '15-step checklist showing complete AI pipeline from input to response',
      path: '/ai-debug',
      icon: '🤖',
      status: 'active'
    },
    {
      name: 'File Upload Debugger',
      description: 'Step-by-step visualization of file uploads to CloudFlare R2',
      component: 'embedded',
      icon: '📁',
      status: 'active'
    },
    {
      name: 'Database Query Debugger',
      description: 'Trace D1 database queries and responses',
      path: '/db-debug',
      icon: '🗃️',
      status: 'planned'
    },
    {
      name: 'Auth Flow Debugger',
      description: 'Visualize JWT token flow and authentication steps',
      path: '/auth-debug',
      icon: '🔐',
      status: 'planned'
    },
    {
      name: 'Worker Performance Monitor',
      description: 'Track CloudFlare Worker execution times and resource usage',
      path: '/perf-debug',
      icon: '⚡',
      status: 'planned'
    }
  ];

  return (
    <div className="max-w-7xl mx-auto p-6">
      <div className="mb-8">
        <h1 className="text-4xl font-bold mb-4 bg-gradient-to-r from-orange-500 to-teal-500 bg-clip-text text-transparent">
          🔧 Debug Tools
        </h1>
        <p className="text-gray-600">
          Diagnostic tools with step-by-step visualization for every moving piece of the GoalYet machine.
        </p>
      </div>

      {/* Tool Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        {tools.map((tool) => (
          <div
            key={tool.name}
            className={`bg-white rounded-lg shadow-lg border p-6 ${
              tool.status === 'active'
                ? 'border-teal-200 hover:border-teal-400'
                : 'border-gray-200 opacity-60'
            } transition-all`}
          >
            <div className="flex items-start justify-between mb-4">
              <div className="text-3xl">{tool.icon}</div>
              <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                tool.status === 'active'
                  ? 'bg-green-100 text-green-800'
                  : 'bg-gray-100 text-gray-600'
              }`}>
                {tool.status}
              </span>
            </div>
            <h3 className="text-xl font-semibold mb-2">{tool.name}</h3>
            <p className="text-gray-600 mb-4">{tool.description}</p>
            {tool.status === 'active' && tool.path && (
              <Link
                to={tool.path}
                className="inline-flex items-center text-teal-600 hover:text-teal-700 font-medium"
              >
                Open Debugger →
              </Link>
            )}
            {tool.status === 'planned' && (
              <span className="text-gray-400 text-sm">Coming soon...</span>
            )}
          </div>
        ))}
      </div>

      {/* Embedded File Upload Debugger */}
      <div className="mb-8">
        <h2 className="text-2xl font-bold mb-4 text-gray-800">
          📁 File Upload Debugger (Embedded)
        </h2>
        <FileUploadDebugger />
      </div>

      {/* Quick Links */}
      <div className="bg-orange-50 rounded-lg border border-orange-200 p-6">
        <h3 className="font-bold text-orange-800 mb-3">🚀 Quick Access</h3>
        <div className="flex flex-wrap gap-3">
          <Link
            to="/ai-debug"
            className="px-4 py-2 bg-white border border-orange-300 rounded-lg hover:bg-orange-100 transition-colors"
          >
            AI Pipeline Checklist
          </Link>
          <Link
            to="/assistant"
            className="px-4 py-2 bg-white border border-teal-300 rounded-lg hover:bg-teal-100 transition-colors"
          >
            Goal Analyzer
          </Link>
          <Link
            to="/api"
            className="px-4 py-2 bg-white border border-gray-300 rounded-lg hover:bg-gray-100 transition-colors"
          >
            API Status
          </Link>
        </div>
      </div>
    </div>
  );
};